<template>
  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100" class="edit-win">
    <FormItem label="角色名" prop="roleName">
      <Input v-model="formValidate.roleName" placeholder="请输入您的角色名"></Input>
    </FormItem>
    <FormItem label="备注" prop="remark">
      <Input v-model="formValidate.remark" placeholder="请输入您的备注"></Input>
    </FormItem>
    <FormItem label="是否是代理商" prop="status">
      <RadioGroup v-model="formValidate.type">
        <Radio :label="1">正常</Radio>
        <Radio :label="0">禁用</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem label="授权" prop="menuIdList">
      <Tree ref="roletree" :data="roleList" show-checkbox></Tree>
    </FormItem>
    <FormItem>
      <Button @click="submitInfo" type="primary">确定</Button>
      <Button @click="back" style="margin-left: 8px">返回</Button>
    </FormItem>
  </Form>
</template>

<script>
export default {
  data () {
    return {
      id: '',
      formValidate: {   //表单参数
        roleName: '',    //角色名称
        remark: '',     //备注
        roleId: '',     //角色id
        menuIdList: {}, //权限id数组
      },
      roleList: [],     //所有权限集合
      tempTreeSelect: [], 
      ruleValidate: {
        roleName: [
          { required: true, message: '角色名不能为空', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    '$route.query.id' () {
      this.getRoleList()
    }
  },
  mounted () {
    this.getRoleList()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getRoleList(){
      let tempAxios = []
      //获取授权所有信息
      tempAxios.push(this.$axios.get('/sys/menu/list'))
      //如果是编辑则根据id获取角色信息
      if(this.$route.query.id) {
        tempAxios.push(this.$axios.get('sys/role/info/'+this.$route.query.id))
      }
      this.$Loading.start()
      this.$axios.all(tempAxios)
        .then(this.$axios.spread(function (...allprower) {
          let isSuccess = true
          allprower.forEach(element => {
            if(!element.data.success) {
              isSuccess = false
            }
          })
          if (isSuccess) {
            //初始化编辑数据
            if(allprower[1])
              this.formValidate = allprower[1].data.data
            //格式化tree所需数据
            this.roleList = this.getChild(0,0, allprower[0].data.data, this.formValidate.menuIdList)
            this.$Loading.finish()
          } else {
            this.$Message.error('请求数据错误')
            this.$Loading.error()
          }
        }.bind(this)))
    },
    //count 3以内的设置为false
    getChild (count,id, data, selected) {
      count++
      let tempList = []
      let tempNode
      //循环格式化tree所需数据
      for(let i = 0; i<data.length; i++) {
        let element = data[i]
        if(element.parentId == id) {
          let isCheck = false
          //如果有选中值的话变量找寻并标记
          if(selected.length>0) {
            for (let i = 0; i < selected.length; i++) {
              if(element.menuId == selected[i]) {
                isCheck = true
                break
              }
            }
          }
          tempNode = {
            id: element.menuId,
            title: element.name,
            expand: true,
            checked: count==3?isCheck:false,
            children: this.getChild(count,element.menuId,data,selected)
          }
          tempList.push(tempNode)
        }
      }
      return tempList
    },
    submitInfo () {
      this.tempTreeSelect = this.$refs.roletree.getCheckedNodes()
      let tempArrayId = []
      this.roleList.forEach(element => {
        let fatherid = []
        let tempIsHit = false
        fatherid.push(element.id)
        element.children.forEach(element1 => {
          element1.children.forEach(element2 => {
            let tempChildHit = false
            this.tempTreeSelect.forEach(element3 => {
              if(element2.id == element3.id) {
                tempArrayId.push(element3.id)
                tempIsHit = true
                tempChildHit = true
              }
            })
            if(tempChildHit) {
              fatherid.push(element1.id)
            }
          })
        })
        if(tempIsHit) {
          tempArrayId = [...tempArrayId,...fatherid]
        }
      })

      this.formValidate.menuIdList = tempArrayId
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let url = ''
          this.$route.query.id ?  url='sys/role/update' : url='sys/role/save'
          this.$axios.post(url,this.formValidate)
            .then(function (response) {
              if(response.data.success){
                this.$Message.success(response.data.data)
                this.$Loading.finish()
							  this.$router.go(-1)
              }else{
                this.$Message.error(response.data.errMsg)
                this.$Loading.error()
              }
            }.bind(this))
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/role/edit.vue